import { TableHead, TableRow } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import TableColumn from 'commons/TableColumn';

import useStyles from './styles';

const TableNewArrivalHead = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <TableHead className={classes.tableHead}>
      <TableRow>
        <TableColumn
          text={t('title')}
          colStyle={classes.columnLongWidth}
        />

        <TableColumn
          text={t('artist')}
          colStyle={classes.columnWidth}
        />

        <TableColumn
          text={t('medium')}
          colStyle={classes.columnWidth}
        />

        <TableColumn
          text={t('year')}
          colStyle={classes.columnWidth}
        />

        <TableColumn
          text={t('size_w_h_d')}
          colStyle={classes.columnWidth}
        />

        <TableColumn
          text={t('price')}
          colStyle={classes.columnWidth}
        />

        <TableColumn
          text={t('in_stock_date')}
          colStyle={classes.columnWidth}
        />

        <TableColumn
          text={t('inv')}
          colStyle={classes.columnWidth}
        />

        <TableColumn
          text={t('location')}
          colStyle={classes.columnWidth}
        />

        <TableColumn
          text={t('status')}
          colStyle={classes.columnWidth}
        />

        <TableColumn
          text={t('action')}
          colStyle={classes.columnWidth}
        />
      </TableRow>
    </TableHead>
  );
};

export default TableNewArrivalHead;
